import { render, staticRenderFns } from "./SystemPageReader.vue?vue&type=template&id=3757e6c4"
import script from "./SystemPageReader.vue?vue&type=script&lang=js"
export * from "./SystemPageReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3757e6c4')) {
      api.createRecord('3757e6c4', component.options)
    } else {
      api.reload('3757e6c4', component.options)
    }
    module.hot.accept("./SystemPageReader.vue?vue&type=template&id=3757e6c4", function () {
      api.rerender('3757e6c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemPage/SystemPageReader.vue"
export default component.exports